/**
 * Recent lookups — a tiny localStorage-backed MRU list of words the user
 * has looked up via <WordPopover>. Shared by useWordPopover and the Command
 * Palette so the list is populated automatically from every entry point.
 */
const STORAGE_KEY = 'iling_recent_lookups_v1';
const MAX_ENTRIES = 12;

export function readRecentLookups() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function pushRecentLookup(entry) {
  if (typeof window === 'undefined') return;
  const { term, lang } = entry || {};
  if (!term || !lang) return;
  const norm = String(term).trim().toLowerCase();
  if (!norm) return;
  try {
    const list = readRecentLookups().filter(
      (e) => !(e.term === norm && e.lang === lang)
    );
    list.unshift({ term: norm, display: String(term).trim(), lang, ts: Date.now() });
    const trimmed = list.slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    // Tiny event so the Command Palette can refresh its view without polling
    window.dispatchEvent(new CustomEvent('iling:recent-lookups-updated'));
  } catch {
    // localStorage can fail in private mode — silent
  }
}

export function clearRecentLookups() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent('iling:recent-lookups-updated'));
  } catch {}
}

export const RECENT_LOOKUPS_EVENT = 'iling:recent-lookups-updated';
